import {
  useHasUserCapability,
  useSafeApiOrgSlug,
  useApiQuery,
} from '@joyful/ui/app'
import { formatNumber } from '@joyful/utils'

const UNTRIAGED_COUNT_REFETCH_INTERVAL_MS = 60_000

/**
 * Polls the count of Dropbox files still needing internal triage.
 */
export function useUntriagedDropboxItemsCount() {
  const orgSlug = useSafeApiOrgSlug()
  const hasCapability = useHasUserCapability()
  const shouldFetchUntriagedCount =
    orgSlug !== null && hasCapability('dropbox.link')

  const untriagedCountQuery = useApiQuery(
    'get',
    '/{org_slug}/dropbox',
    {
      params: {
        path: {
          org_slug: orgSlug ?? '',
        },
        query: {
          limit: 1,
          offset: 0,
          source: 'PRACTICE_UPLOAD',
          status: ['UNTRIAGED'],
        },
      },
    },
    {
      enabled: shouldFetchUntriagedCount,
      refetchInterval: UNTRIAGED_COUNT_REFETCH_INTERVAL_MS,
      refetchOnWindowFocus: false,
    },
  )

  const untriagedCount = untriagedCountQuery.isSuccess
    ? untriagedCountQuery.data.total
    : 0
  const formattedUntriagedCount =
    untriagedCount > 10 ? `10+` : formatNumber(untriagedCount)

  return { formattedUntriagedCount, untriagedCount }
}
